import { RootState } from "@/app/stores"

export const selectLatestTransactions = (state: RootState) => state.companyTransactionsStatistics.latestTransactions
export const selectTransactionDetails = (state: RootState) => state.companyTransactionsStatistics.transactionDetails
export const selectTransactionsLoading = (state: RootState) => state.companyTransactionsStatistics.isLoading
export const selectTransactionsFirstLoad = (state: RootState) => state.companyTransactionsStatistics.isFirstLoad
export const selectTransactionsError = (state: RootState) => state.companyTransactionsStatistics.error

